import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Input } from "design-react-kit";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import ViewPDF from "../../Components/ViewPDF";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}






function CheckISEE(props) {
  const apiToken = useContext(TokenContext);
  const [value, setValue] = useState("");
  const [file, setFile] = useState();
  const [userData, setUserData] = useState();
  const [validation, setValidation] = useState(false);
  const [loading, setLoading] = useState(true);

  let query = useQuery();
  let idIsee = query.get("idIsee");
  useEffect(() => {
    setLoading(false);
    if (idIsee) {
      var obj = document.createElement("object");
      obj.type = "application/pdf";
      obj.data = "data:application/pdf;base64," ;
      obj.length =0;
      setFile(obj);
      console.log(obj.length);

      Repo.getIsee(apiToken, idIsee)
        .then((response) => {
          if (response.status == 200) {
         
            obj.type = "application/pdf";
            obj.data = "data:application/pdf;base64," + response.data.file;
            obj.length =  response.data.file.length;
        console.log(obj.length);
            setFile(obj);
            setValue(response.data.value);
            setUserData(response.data.user);
          }
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  return (
    <>
      <div>
        <h1>Visualizza ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Visualizza i dettagli dell'ISEE</p>
          </div>

        <div className="row mb-2">
          <div className="col-12">
            <div className="top card-wrapper card-space">
              <div className="card card-bg no-after roundedCustom p-2">
                <div className="card-body">
                  <h6 className="mb-1">Dati Cittadino</h6>
                  <div className="row">
                    <div className="col-lg-4">
                      Nome: <strong>{userData && userData.firstName}</strong>
                    </div>
                    <div className="col-lg-4">
                      Cognome: <strong>{userData && userData.lastName}</strong>
                    </div>
                    <div className="col-lg-4">
                      Codice Fiscale:{" "}
                      <strong>{userData && userData.fiscalCode}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
         
        <ViewPDF data={file && file.data} length={file && file.length}/>

   

          <div className="col-lg-4 pl-5">
            <div className="top card-space">
              <div className="card card-bg card-big roundedCustom">
                <div className="card-body">
                  <h6 className="mt-3 mb-1">Valore ISEE</h6>
                  <div className="row mb-4">
                    <Input
                      id="value"
                      type="number"
                      required
                      disabled
                      value={value && value.toString()}
                      name="Valore ISEE"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!loading && <Loader></Loader>}
    </>
  );
}

export default CheckISEE;
